export const github = 'https://github.com/hexalang'
export const patreon = 'https://www.patreon.com/PeyTy'
export const news = 'https://t.me/s/hexalang_news'
export const downloads = '?'
export const discord = 'https://discord.gg/SsAWf9M'
export const background = 'https://www.shadertoy.com/embed/$?gui=false&t=10&gui=false&paused=false&muted=true'
export const animation = 'XXfyzB'
export const youtube = 'https://www.youtube.com/channel/UChcz5b20vDOk4ERoPs-pCbw'
export const telegram = 'https://t.me/s/hexalang_news/42'
export const telegramChat = 'https://t.me/hexalang'
export const year = new Date().getFullYear()
